import { render, staticRenderFns } from "./userIntegralDetail.vue?vue&type=template&id=46622992&"
import script from "./userIntegralDetail.vue?vue&type=script&lang=js&"
export * from "./userIntegralDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports